<template>

  <page>
    <object-tag slot="page-title" type="Dashboard"/>
    <p class="subtitle">Recent Jobs</p>
    <job-status-filter
      :selected="jobTableState"
      @change="handleJobStatusFilter"
    />
    <data-table
      class="table"
      :columns="jobTable.columns"
      :rows="jobTable.rows"
      :limit="jobTable.limit"
      :total="jobTable.total"
      @onClickRow="navigateToJob"
    />
  </page>

</template>
<script>

  import {mapGetters, mapActions} from 'vuex';
  import ObjectTag from '~/components/page/ObjectTag.vue';
  import InquiryContext from './mixins/InquiryContext.vue';
  import JobContext from './mixins/JobContext.vue';
  import {DataTable, DataPager} from '~/lib/vue/components/datatables';
  import JobStatusFilter from '~/components/job/JobStatusFilter.vue';
  import P from '~/lib/promise';
  import Page from '~/components/Page.vue';

  export default {
    mixins: [InquiryContext, JobContext],

    components: {
      ObjectTag,
      DataTable,
      DataPager,
      JobStatusFilter,
      Page,
    },

    mounted () {
      let query = {
        sorts: {updated_at: 'desc'},
        paging: {limit: 10}
      };

      // Clear before the first paint, so Recent Jobs does not show the rows
      // from whatever job list was open before.
      this.initializeJobTable({url: '/jobs', query});

      (async () => {

        // loadJobTable restores any remembered status filter before fetching;
        // setJobTableLimit alone would skip it. The limit still comes from
        // the page rather than storage, because "Recent Jobs" is a ten-row
        // summary regardless of the limit chosen on the Job index.
        await this.loadJobTable();
        await this.setJobTableLimit(10);

      })();
    }

  };

</script>
